// extracted by mini-css-extract-plugin
export default {"productGallery":"_H-z","inQuickShop":"aI-z"};